import StrategyConstraintInputField from './StrategyConstraintInputField';

export default StrategyConstraintInputField;
